import React, { useState, useEffect } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  ManageRestaurant,
  showMessage,
  getToken,
  formatTime,
  trimFirstAndLastWhiteSpace,
  handleImageError,
} from "../../Functionalities/Functions";
import "./Assets/css/restaurants.css";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import axios from "axios";
import {
  protocol,
  works_in_franchise,
} from "../../Functionalities/Config";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { ManageFeatured } from "./Logic";
import ToggleButton from "../../CoreComponents/ToggleButton";
import LoadingComponent from "../../CoreComponents/LoadingComponent";

import ProductsList from "../../CoreComponents/ProductsList";

function Body() {
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [featured, setFeatured] = useState({
    id: "",
    is_featured: "",
  });

  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [filter, setfilter] = useState({
    id: "",
    search_text: "",
    is_blocked: "",
  });
  const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isFilterApplied, setisFilterApplied] = useState(false);

  // useEffect(() => {
  //   if (localStorage.getItem('rest_filter')) {
  //     setfilter(JSON.parse(localStorage.getItem('rest_filter')))
  //     setisFilterApplied(true)
  //   } else {
  //     setfilter({ ...filter, id: '', search_text: '', is_blocked: '' })
  //   }

  // }, [])

  // useEffect(() => {
  //   isFilterApplied && getData(); setisFilterApplied(false)
  // }, [isFilterApplied])

  useEffect(() => {
    getData();
    (works_in_franchise) &&
      getBranches();
  }, [reload]);

  let params =
    "resto_list=true&id=" +
    filter.id +
    "&search_text=" +
    trimFirstAndLastWhiteSpace(filter.search_text);

  const getData = () => {
    if (filter.is_blocked) {
      params = params + "&is_blocked=false";
    }
    // showMessage(
    //   "Loading restaurant",
    //   "info",
    //   "Loading",
    //   "bottom", "bottom-left",
    //   0
    // );

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        if (result !== 0) {
          setData({
            ...data,
            data: result?.data?.results,
            count: result?.data?.count,
          });
          setNext(result.data.next);
          setPrev(result.data.previous);
        }
        setLoading(false);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");

    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
          count: response.data.count,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const getBranches = () => {
    let params = "for_dropdown=true&page_wise=false&order_by_name=true";

    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        //shabeeb change start

        // showMessage(
        //   JSON.stringify(result),
        //   "success",
        //   "Loading",
        //   "top",
        //   "top-center",
        //   0
        // );

        //shabeeb change end

        setrestrarent({
          ...restrarent,
          data: result?.data,
        });
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-right", //shabeeb change
          0
        );
      });
  };

  // void 0
  return (
    <div className="content-body">
      {!loading ? (
        <div className="container-fluid">
          <FilterComponent
            handleNext={handleNext}
            handlePrev={handlePrev}
            next={next}
            prev={prev}
            count={data.count}
            addItemName={"Add Restaurant"}
            addItemPath={"/addrestaurant"}
            filterButtonName={"Filter"}
          />
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card">
                <FilterModalComponent
                  heading={"Filter Restaurants"}
                  searchItemValue={filter.search_text}
                  searchItemChange={(e) =>
                    setfilter({
                      ...filter,
                      search_text: e.target.value,
                    })
                  }
                  clearFilter={(e) => {
                    e.preventDefault();
                    window.location.reload();
                    setfilter({
                      ...filter,
                      id: "",
                      search_text: "",
                      is_blocked: "",
                    });
                  }}
                  submitFilter={(e) => {
                    e.preventDefault();
                    getData();
                    localStorage.setItem("rest_filter", JSON.stringify(filter));
                  }}
                >
                  {works_in_franchise && (
                    <>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="text-black font-w600">
                            Restaurant <span className="required"></span>
                          </label>
                          <select
                            value={filter.id}
                            class="form-control form-control-lg"
                            onChange={(e) =>
                              setfilter({
                                ...filter,
                                id: e.target.value,
                              })
                            }
                          >
                            <option value={""} id={""}>
                              All
                            </option>
                            {restrarent?.data?.map((item) => (
                              <option value={item.id} id={item.id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label className="text-black font-w600">
                            Blocked <span className="required"></span>
                          </label>
                          <select
                            value={filter.id}
                            class="form-control form-control-lg"
                            onChange={(e) =>
                              setfilter({
                                ...filter,
                                is_blocked: e.target.value,
                              })
                            }
                          >
                            <option value={""} id={""}>
                              Not apply
                            </option>
                            <option value={"true"} id={""}>
                              yes
                            </option>
                          </select>
                        </div>
                      </div>
                    </>
                  )}
                </FilterModalComponent>

                <div className="card-body most-favourite-items pb-0">
                  <div className="tab-content">
                    <div
                      className="tab-pane fade show active"
                      id="all-categories"
                    >
                      <div className="row">
                        {data.data.length > 0 ? (
                          data.data.map((restaurant, index) => {
                            let data_img =
                              "https://static.thenounproject.com/png/2879926-200.png";
                            if (
                              restaurant.images &&
                              restaurant.images.length > 0
                            ) {
                              data_img = restaurant.images[0].image;
                            }
                            return (
                              <div id={restaurant.id} className="col-lg-4 mb-2">
                                <div className="media mb-4 align-items-center applyborder p-2">
                                  <a
                                    className="text-black"
                                    href={`/restaurant/${restaurant.id}`}
                                  >
                                    <div
                                      style={{
                                        width: "100px",
                                        position: "absolute",
                                        height: "100px",
                                      }}
                                    >
                                      <strong
                                        style={{
                                          position: "absolute",
                                          bottom: 0,
                                          width: "100px",
                                          backgroundColor:
                                            restaurant.product_count === 0
                                              ? "#de0202"
                                              : "#51B04A",
                                          fontSize: "13px",
                                          color: "white",
                                          borderRadius: "10px",
                                          padding: 5,
                                          textAlign: "center",
                                        }}
                                      >
                                        {restaurant.product_count === 0
                                          ? "No Products"
                                          : restaurant.product_count +
                                            " Products"}
                                      </strong>
                                    </div>

                                    {restaurant.is_featured && (
                                      <strong
                                        style={{
                                          position: "absolute",
                                          backgroundColor: "#de0202",
                                          color: "white",
                                          borderTopLeftRadius: "10px",
                                          borderBottomRightRadius: "10px",
                                          paddingLeft: "5px",
                                          paddingRight: "5px",
                                          fontSize: "13px",
                                          paddingTop: "2px",
                                          marginBottom: "1px",
                                        }}
                                      >
                                        Featured
                                      </strong>
                                    )}
                                    {restaurant.free_delivery && (
                                      <span className="badge badge-success ml-1" style={{ fontSize: "11px" }}>Free delivery</span>
                                    )}
                                    {restaurant.is_blocked && (
                                      <div
                                        style={{
                                          width: "100px",
                                          position: "absolute",
                                          height: "100px",
                                          backgroundColor: " rgba(0, 0, 0,0.3)",
                                          borderRadius: "10px",
                                          marginRight: 15,
                                          borderWidth: "2px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <strong
                                          style={{
                                            color: "white",
                                            fontSize: "16px",
                                            width: "100%",
                                            marginVertical: 10,
                                            backgroundColor: "black",
                                            textAlign: "center",
                                            padding: 3,
                                          }}
                                        >
                                          Blocked
                                        </strong>
                                      </div>
                                    )}
                                    <img
                                      height="100"
                                      width="100"
                                      style={{
                                        borderRadius: "10px",
                                        marginRight: 15,
                                        borderWidth: "2px",
                                        border: "2px solid #000",
                                      }}
                                      src={data_img}
                                      alt={"foodoor"}
                                      onError={handleImageError}
                                    />
                                  </a>

                                  <div className="media-body">
                                    <span className="fs-16 text-black">
                                      <a
                                        className="text-black"
                                        href={`/restaurant/${restaurant.id}`}
                                      >
                                        {restaurant.name}
                                      </a>
                                    </span>

                                    {restaurant.mobile && (
                                      <span className="fs-12 text-black">
                                        <br />

                                        {restaurant.mobile}
                                      </span>
                                    )}

                                    <span className="fs-12 text-black">
                                      <br />
                                      {formatTime(
                                        restaurant.opening_time
                                      )} - {formatTime(restaurant.closing_time)}
                                    </span>

                                    {restaurant.is_closed && (
                                      <span>
                                        <br />
                                        <span
                                          className={
                                            restaurant.is_closed &&
                                            "bg-primary text-white p-1 fs-12"
                                          }
                                          style={{ borderRadius: "5px" }}
                                        >
                                          Not active
                                        </span>
                                      </span>
                                    )}

                                    {restaurant.commission == 0 ? (
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          border: "1px solid red",
                                          borderRadius: "5px",
                                          padding: "3px",
                                          borderColor: "red",
                                          backgroundColor: "red",
                                          color: "white",
                                          fontWeight: "bold",
                                          fontSize: 12,
                                        }}
                                      >
                                        Commission Not Set
                                      </div>
                                    ) : (
                                      <div
                                        className="mt-2"
                                        style={{
                                          marginTop: "10px",
                                          border: "1px solid red",
                                          borderRadius: "5px",
                                          padding: "3px",
                                          borderColor: "#51B04A",
                                          fontWeight: "bold",
                                          color: "white",
                                          backgroundColor: "#51B04A",
                                          fontSize: 12,
                                        }}
                                      >
                                        Commission : {restaurant.commission}%
                                      </div>
                                    )}
                                    <span className="fs-12 text-black">
                                      <div className="row">
                                        {/* <span className="col mt-2">{restaurant.is_featured ? " Featured" : "Not Featured"}</span> */}
                                        <div
                                          className="col"
                                          style={{
                                            display: "flex",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <span>Featured &nbsp;</span>
                                          <ToggleButton
                                            inactiveLabel={""}
                                            activeLabel={""}
                                            // colors={{
                                            //   activeThumb: {
                                            //     base: '#ED3833',
                                            //   },
                                            //   inactiveThumb: {
                                            //     base: '#51B04A',
                                            //   },
                                            // }}
                                            value={
                                              restaurant.is_featured || false
                                            }
                                            checked={restaurant.is_featured}
                                            thumbStyle={{ borderradius: 5 }}
                                            trackStyle={{ borderradius: 5 }}
                                            onToggle={(e) => {
                                              // void 0
                                              if (restaurant.is_closed) {
                                                showMessage(
                                                  "restaurant closed ,please activate.",
                                                  "danger",
                                                  "Error!",
                                                  "top",
                                                  "top-right",
                                                  0
                                                );
                                              } else {
                                                setFeatured({
                                                  ...featured,
                                                  is_featured: !e,
                                                  id: restaurant.id,
                                                });
                                                var x = {
                                                  ...featured,
                                                  is_featured: !e,
                                                  id: restaurant.id,
                                                };
                                                let result = ManageFeatured(
                                                  e,
                                                  x,
                                                  "update",
                                                  ""
                                                );
                                                result
                                                  .then((result) => {
                                                    if (
                                                      result.data.Status ===
                                                      true
                                                    ) {
                                                      var newData = data.data;
                                                      var newObj =
                                                        newData[index];
                                                      newObj = {
                                                        ...newObj,
                                                        is_featured: !e,
                                                      };
                                                      newData[index] = newObj;
                                                      setData({
                                                        ...data,
                                                        data: newData,
                                                      });
                                                      // void 0
                                                      //window.location.reload()
                                                      setReload(!reload);
                                                    } else {
                                                      showMessage(
                                                        result.data.Error,
                                                        "danger",
                                                        "Error!",
                                                        "top",
                                                        "top-right",
                                                        0
                                                      );
                                                    }
                                                  })
                                                  .catch((error) => {
                                                    // void 0
                                                  });
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <NoDataComponent data="restaurants" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}
function Restaurants() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Restaurants"}
          subHeading={"All Restaurants under foodoor"}
        />
        <NavBar />
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Restaurants;
